<template>
    <div class="ls-address-row">
        <div class="ls-address-row__address-display">
            <a
                v-ls-track.click="{
                    target: 'change-address--icon',
                }"
                class="ls-address-row__icon"
                aria-label="Change Address Icon"
                @click.prevent="openModal('changeAddress')"
            >
                <span class="fa fa-fw fa-stack">
                    <i
                        class="fa fa-stack-2x fa-map"
                        :class="{
                            'ls-color--gray--xx-light': desktop,
                            'ls-color--gray--x-light': !desktop,
                        }"
                    ></i>
                    <i class="fa fa-stack-1x fa-map-marker ls-color--red--color-dodge"></i>
                </span>
            </a>

            <a
                v-ls-track.click="{
                    target: 'change-address--text',
                }"
                class="ls-address-row__address-name"
                aria-label="Change Address Text"
                @click.prevent="openModal('changeAddress')"
            >
                <strong data-font-size="-1">
                    {{ order.address.street }}
                </strong>
                <br />
                <span class="ls-truncate ls-color--gray--mid" data-font-size="-2">
                    {{ order.address.city }},
                    {{ order.address.state }}
                    {{ order.address.zip }}
                </span>
            </a>
            <div style="margin-left: 5px;">
                <button
                    v-ls-track.click="{
                        target: 'change-address--button',
                    }"
                    class="ls-button ls-button--sm"
                    :class="{
                        'ls-button--white': !order.saved_order,
                        'ls-button--blue': order.saved_order,
                    }"
                    type="button"
                    @click.prevent="openModal('changeAddress')"
                >
                    Change
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import * as types from '@/store/types';

export default {
    computed: {
        ...mapState(['order']),
        ...mapGetters({
            desktop: types.SCREEN_SIZE__GET_DESKTOP_SCREEN,
        }),
    },
    methods: {
        ...mapActions({
            openModal: types.MODAL__OPEN_MODAL,
        }),
    },
};
</script>

<style lang="scss" scoped>
.ls-address-row__address-display {
    display: flex;
    align-items: center;
    padding: rem(-4);
}

.ls-address-row__address-name {
    display: inline-block;
    position: relative;
    flex: 1 1 auto;
    width: 0;
    max-width: 100%;
    margin: 0;
    margin-left: rem(-3);
}

.themed-lawnlove {
    .ls-address-row {
        .ls-address-row__address-display {
            .ls-button {
                color: $theme-color-white;
                background: $theme-color-primary;
                border-color: $theme-color-primary;
                border-radius: 6px;
                box-shadow: none;
                &:hover {
                    border-color: $theme-color-primary-dark;
                    background: $theme-color-primary-dark;
                }
            }
        }
    }
}
</style>
